import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';

@Injectable({ providedIn: 'root' })
export class BannerService {
  constructor(private http: HttpClient) { }

  getBanner(): Observable<any> {
    return this.http
      .get(`${environment.api.banner.get}`)
      .pipe(map((res) => res));
  }
}
